<!-- eslint-disable vue/no-v-html -->
<template>
  <BaseModal
    id="confirmBook"
    :title="$label('subscription.basic.confirmBookModal.title')"
    footer-class="modal-footer--confirmBook"
    :static-modal="staticModal"
  >
    <template #body>
      <div class="d-flex mb-32">
        <div class="mr-32">
          <BookCover
            :title="book.title"
            :cover="book.cover"
            :width="100"
            :height="153.73"
          />
        </div>

        <div class="book-info">
          <div
            v-if="numberOfRatings"
            class="modal__reviews d-flex align-items-center mb-16 flex-wrap"
          >
            <StarsRating :rating="averageRating" />
            <small class="modal__reviews-num text-small ml-16">
              {{ bookRatingsLabel }}
            </small>
          </div>

          <h2 class="mb-8" data-testid="book-title">
            {{ book.title }}
          </h2>

          <span v-if="book.author" class="fw-semibold mb-24 d-block">
            {{ book.author.name }}
          </span>
        </div>
      </div>

      <div class="mb-32">
        <p v-html="$label('subscription.basic.confirmBookModal.text')" />
      </div>

      <div class="modal__buttons">
        <BaseButton
          variant="call-to-action"
          :class="['confirm-btn', { loading: isLoading }]"
          data-testid="confirm-btn"
          @click="confirmBook"
        >
          {{ $label('subscription.basic.confirmBookModal.confirmBtn') }}
        </BaseButton>
        <BaseButton class="cancel-btn" variant="secondary" @click="hideModal">
          {{ $label('common.cancel') }}
        </BaseButton>
      </div>
    </template>

    <template #footer>
      <UpgradeToPremiumBlock />
    </template>
  </BaseModal>
</template>

<script>
import { mapActions } from 'pinia'
import { useBooksStore } from '~/stores/books'
import BaseModal from '~/components/BaseModal'
import UpgradeToPremiumBlock from '~/components/basicSubscription/UpgradeToPremiumBlock'
import StarsRating from '~/components/reviews/StarsRating'
import { useReviews } from '~/composables/useReviews'
import BookCover from '~/components/books/BookCover'
import { CHOOSE_BOOK_ERRORS } from '~/utils/constants'

export default {
  components: {
    BaseModal,
    UpgradeToPremiumBlock,
    StarsRating,
    BookCover
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    hideModal: {
      type: Function,
      required: true
    },
    staticModal: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const book = toRef(props, 'book')
    const { averageRating, numberOfRatings, bookRatingsLabel } = useReviews(
      book.value
    )

    return {
      averageRating,
      numberOfRatings,
      bookRatingsLabel
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapActions(useBooksStore, ['confirmChosenBook', 'getChosenBooks']),
    async confirmBook() {
      this.isLoading = true

      try {
        await this.confirmChosenBook(this.book.slug)
        await this.getChosenBooks(this.book.categoryCode)
        this.$localStorage.addItem('chosenBook', this.book.slug, 1)

        this.hideModal()
      } catch (error) {
        const errorCode = this.$error.getLabel(error)
        const errorLabel = CHOOSE_BOOK_ERRORS.includes(errorCode)
          ? errorCode
          : 'messages.errorOccuredMessage'

        this.hideModal()
        this.$toast.error(this.$label(errorLabel))
        this.$sentryCaptureException(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 172px;
  white-space: inherit;

  &:first-child {
    margin-right: 16px;
  }
}

.book-info {
  flex: 1;
}

@include media-breakpoint-down(sm) {
  .modal__reviews {
    max-width: 110px;
  }

  .modal__reviews-num {
    margin-left: 0;
    margin-bottom: 8px;
    order: 1;
  }

  .stars-rating {
    order: 2;
  }

  .modal__buttons {
    display: flex;
    flex-direction: column;
  }

  .btn {
    &:first-child {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
}
</style>
